import { render, staticRenderFns } from "./MasterSertifikasiTambah.vue?vue&type=template&id=c6048b6a&scoped=true&"
import script from "./MasterSertifikasiTambah.vue?vue&type=script&lang=js&"
export * from "./MasterSertifikasiTambah.vue?vue&type=script&lang=js&"
import style0 from "./MasterSertifikasiTambah.vue?vue&type=style&index=0&id=c6048b6a&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6048b6a",
  null
  
)

export default component.exports